import { graphql, useStaticQuery } from 'gatsby'

const useCampaigns = ({ campaignId = '' } = {}) => {
  const data = useStaticQuery(graphql`
    query {
      allCampaign(filter: { id: { ne: "placeholder" } }) {
        nodes {
          id
          description
          name
          applications {
            id
          }
          attributes {
            tags
          }
          properties {
            background
            logo
            image
            image2x
            image3x
            promoHeading
            copyHeading
            copyDescription
            buttonCopy
            buttonRoute
          }
        }
      }

      allApp {
        nodes {
          id
          slug
          name
          installations
          shortDescription
          product
          category {
            id
            name
            slug
          }
          icons {
            id
            large
            original
            small
            title
          }
          payment {
            frequency
            price
          }
          customProps {
            appVideoUrl
            hiddenForBeta
            isService
            usingBeta
          }
          hidden
          longDescription
          tutorialUrl
        }
      }

      allService {
        nodes {
          id
          slug
          name
          installations
          shortDescription
          category {
            id
            name
            slug
          }
          icons {
            id
            large
            original
            small
            title
          }
          customProps {
            appVideoUrl
            hiddenForBeta
            isService
            usingBeta
          }
          hidden
          longDescription
          tutorialUrl
        }
      }
    }
  `)

  const allCampaigns = data.allCampaign.nodes
  const allApps = data.allApp.nodes
  const allServices = data.allService.nodes
  const allItems = [...allApps, ...allServices]

  // Convert apps/services to have the same structure as redux store
  const items = allItems.reduce((obj, item) => {
    obj[item.id] = item
    return obj
  }, {})

  const findCampaign = (campaignId) => {
    const campaign = allCampaigns.find(
      ({ id }) => id === String(campaignId).trim()
    )

    if (campaign?.applications?.length) {
      const campaignApps = campaign.applications
        ?.map((app) => items[(app?.id)])
        ?.filter(Boolean)
      campaign.applications = campaignApps
    }

    return campaign
  }

  const campaigns = campaignId
    .split(',')
    .map(findCampaign)
    .filter(Boolean)

  return {
    apps: items,
    campaigns,
    allCampaigns,
    findCampaign,
  }
}

export default useCampaigns
